"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveConnectTarget = void 0;
const path_1 = require("../utils/path");
const MapResultNode_1 = require("./MapResultNode");
function resolveConnectTarget(dataMapper, target) {
    let node = target instanceof MapResultNode_1.MapResultNode ? target : dataMapper.resultNodesByPath.get(target);
    let relativePathPartsToNode;
    let relativePathToNode;
    if (!node && typeof target === 'string') {
        // 当前 path 没有直接指向的 MapResultNode，需要向上追溯
        let tmpPath = target;
        relativePathPartsToNode = [];
        relativePathToNode = '';
        while (tmpPath && !node) {
            const sep = (0, path_1.popPath)(tmpPath);
            if (!sep)
                break;
            const [remainder, key] = sep;
            node = dataMapper.resultNodesByPath.get(remainder);
            relativePathPartsToNode.unshift(key);
            relativePathToNode = tmpPath.slice(remainder.length) + relativePathToNode;
            tmpPath = remainder;
        }
    }
    if (!node)
        throw new Error(`Cannot connect to target ${target}`);
    return { node, relativePathPartsToNode, relativePathToNode };
}
exports.resolveConnectTarget = resolveConnectTarget;
